import { useState } from 'react';

import CodeModal from "../CodeModal";
import { 
  FILE_EXTENSION_MAP, 
  OPEN_KATTIS_SOLUTION_PATH,
  OPEN_KATTIS_REPO,
  OPEN_KATTIS_WEBSITE_LINK, 
  SORT_COLUMN_KEYS 
} from "../../utils/DataParser";

export default function OpenKattisTable({ openKattisData }) {
  const [codeModalData, setCodeModalData] = useState({
    name: 'Hello World!',
    language: 'Java',
    path: 'Java/hello.java',
    repo: OPEN_KATTIS_REPO
  });

  const [modal, setModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  //const [tableSortedBy, setTableSortedBy]
  const tableSortedBy = {
    sortKey: SORT_COLUMN_KEYS[0],
    isAscending: true
  };

  function sortTableRows(tableRows) {
    const { sortKey, isAscending } = tableSortedBy;

    return tableRows.sort((row1, row2) => {
      if (row1[sortKey].toString() > row2[sortKey].toString()) return isAscending ? 1 : -1;
      if (row2[sortKey].toString() > row1[sortKey].toString()) return isAscending ? -1 : 1;

      return 0;
    });
  }

  function searchFilter(tableRows) {
    return tableRows.filter((tableRow) =>
      SORT_COLUMN_KEYS.some((column) =>
        tableRow[column].toLowerCase().indexOf(searchQuery.toLowerCase()) > -1
      )
    );
  }

  const filterTable = () => sortTableRows(searchFilter(openKattisData));

  const showCodeModal = (e) => {
    e.preventDefault();
    const problemId = e.currentTarget.getAttribute('data-problem-id');
    const problemName = e.currentTarget.getAttribute('data-problem-name');
    const codeLanguage = e.currentTarget.getAttribute('data-problem-language');
    const codePath = `${codeLanguage}/${problemId}.${FILE_EXTENSION_MAP[codeLanguage]}`;
    
    setCodeModalData((prevState) => ({
      ...prevState,
      name: problemName,
      language: codeLanguage,
      path: codePath,
      repo: OPEN_KATTIS_REPO
    }));

    setModal(!modal);
  }

  const hideCodeModal = () => setModal(!modal);
  // https://codesandbox.io/s/react-responsive-nav-3n3lu?file=/src/components/Navbar.js  

  return (
    <>
      <div className='flex-container-row'>
        <div className='table-container'>
          
          <div className="search">
            <button className="searchButton">
              <i className="fa fa-search"></i>
            </button>
            <input
              className="searchTerm"
              type='text'
              value={searchQuery}
              placeholder='Search questions'
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <table className='problem-list-table'>
            <thead>
              <tr>
                <th className="text-left">
                  <div>Problem</div>
                </th>
                <th className="text-center">ID</th>
                <th className="text-center">Difficulty</th>
                <th className="text-center">Code</th>
              </tr>
            </thead>
            <tbody>
              {
                filterTable().map((tableRow) => {
                  return (
                    <tr key={`OpenKattis-${tableRow.problemId}`}>
                      <td className='text-left' data-label="Problem: ">
                        <a href={`${OPEN_KATTIS_WEBSITE_LINK}${tableRow.problemId}`} target="_blank" rel="noopener noreferrer">
                          {tableRow.problemName}
                        </a>
                      </td>
                      <td className='text-center' data-label="ID: ">{tableRow.problemId}</td>
                      <td className="text-center" data-label="Difficulty: ">
                        <div className="flex-container-row">
                          {
                            tableRow.difficulty === 'Easy' ?
                              (
                                <button className="problem-button easy-btn">
                                  <b>Easy</b>
                                </button>
                              ) : tableRow.difficulty === 'Medium' ?
                                (
                                  <button className="problem-button medium-btn">
                                    <b>Medium</b>
                                  </button>
                                ) : (
                                  <button className="problem-button hard-btn">
                                    <b>Hard</b>
                                  </button>
                                )
                          }
                        </div>
                      </td>
                      <td className="text-center" data-label="Code: ">
                        <div className="flex-container-row">
                          {
                            tableRow.languages.map((language) => {
                              return (
                                <button 
                                  key={`${tableRow.problemId}-${language}`}
                                  className='problem-button code-solution-btn'
                                  data-problem-id={tableRow.problemId}
                                  data-problem-name={tableRow.problemName}
                                  data-problem-language={language}
                                  onClick={showCodeModal}
                                >
                                  <b>{language}</b>
                                </button>
                              )
                            })
                          }
                        </div>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
      <CodeModal 
        close={hideCodeModal} 
        data={codeModalData} 
        show={modal} 
        solutionPath={OPEN_KATTIS_SOLUTION_PATH}
      />
    </>
  )
}